import {
  ClockConfig,
  UsaFlagIcon,
  GermanyFlagIcon,
  EstoniaFlagIcon,
  IndiaFlagIcon,
  ChinaFlagIcon,
} from '@xlrt/components';

export const clockConfigs: ClockConfig[] = [
  {
    label: 'SEA',
    timeZone: 'America/Los_Angeles',
    Icon: UsaFlagIcon,
  },
  {
    label: 'BER',
    timeZone: 'Europe/Berlin',
    Icon: GermanyFlagIcon,
  },
  {
    label: 'TLL',
    timeZone: 'Europe/Tallinn',
    Icon: EstoniaFlagIcon,
  },
  {
    label: 'BLR',
    timeZone: 'Asia/Kolkata',
    Icon: IndiaFlagIcon,
  },
  {
    label: 'PEK',
    timeZone: 'Asia/Shanghai',
    Icon: ChinaFlagIcon,
  },
];

export const timeFormat: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

/**
 * Names of the widgets in the grid layout. Saved layouts of users refer to
 * them, so they keep the names of the legacy dashboard extensions.
 */
export const QUICK_START_WIDGET_NAME = 'QuickStart Menu';
export const FAVORITES_WIDGET_NAME = 'DashboardFavorites';
export const RECENTLY_VISITED_WIDGET_NAME = 'Recently Visited';
export const TOP_VISITED_WIDGET_NAME = 'Top Visited';
export const TOOLKIT_WIDGET_NAME = 'DashboardToolkit';
export const ANNOUNCEMENTS_WIDGET_NAME = 'Announcements';

export const defaultConfig = [
  {
    component: QUICK_START_WIDGET_NAME,
    x: 0,
    y: 0,
    width: 24,
    height: 3,
    resizable: false,
  },
  {
    component: FAVORITES_WIDGET_NAME,
    x: 0,
    y: 0,
    width: 6,
    height: 6,
  },
  {
    component: RECENTLY_VISITED_WIDGET_NAME,
    x: 6,
    y: 0,
    width: 6,
    height: 6,
  },
  {
    component: TOOLKIT_WIDGET_NAME,
    x: 0,
    y: 6,
    width: 6,
    height: 6,
  },
  {
    component: ANNOUNCEMENTS_WIDGET_NAME,
    x: 6,
    y: 6,
    width: 6,
    height: 6,
  },
];
export const defaultCols = {
  xxs: 2,
  xs: 4,
  sm: 6,
  md: 12,
  lg: 12,
  xl: 12,
};
